import { render, staticRenderFns } from "./CopyrightTwo.vue?vue&type=template&id=2d8e1332"
import script from "./CopyrightTwo.vue?vue&type=script&lang=js"
export * from "./CopyrightTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports